var _a;
import { configureStore, combineReducers } from '@reduxjs/toolkit';
// import { api } from '@services/BaseApi';
// import { refreshTokenMiddleWare } from '../services/middleware/refreshTokenMiddleWare';
import { authReducer } from './slices/authSlice';
import { modalReducer } from './slices/modal';
import { api } from '@/services/baseApi';
// import { singleChatReducer } from './slices/chatSlice';
var rootReducer = combineReducers((_a = {},
    _a[api.reducerPath] = api.reducer,
    _a.authStich = authReducer,
    _a.modals = modalReducer,
    _a));
export var setupStore = function () {
    return configureStore({
        reducer: rootReducer,
        middleware: function (getDefaultMiddleware) {
            return getDefaultMiddleware().concat(api.middleware);
        },
    });
};
